import { DependencyInjectionContainer } from "./dependency-injection-container";
import { RolesPermissionsService } from "../roles-permissions/services/roles-permissions-service";

const key = "rolesPermissionService";

export const getRolesPermissionsService = () => {
  return DependencyInjectionContainer.getInstance().resolve<RolesPermissionsService>(
    key,
  );
};

export const registerRolesPermissionsService = () => {
  DependencyInjectionContainer.getInstance().register(
    key,
    RolesPermissionsService,
  );
};
